// src/components/Login.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import styles from "../../css/MainPage.module.css"; // Using scoped CSS for styling
import { useUser } from '../../Navbar/UserContext';
import { useAuth } from '../../contexts/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login: userLogin } = useUser();
  const { login: authLogin } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');

    try {
      const response = await axios.post('https://techservicemarket-backend.onrender.com/api/recruiter/login', {
        username,
        password,
      });

      const { token, id } = response.data;
      
      // Set in both contexts
      userLogin(token, { id, firstName: username.split('@')[0], lastName: '' });
      authLogin(token, { id, firstName: username.split('@')[0], lastName: '' }, 'recruiter');
      
      // Store in localStorage
      localStorage.setItem('userId', id);
      localStorage.setItem('token', token);
      localStorage.setItem('lastPath', '/recruiter/dashboard');
      
      navigate('/recruiter/dashboard');
    } catch (error) {
      setErrorMessage(error.response?.data?.msg || "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.mainPageBody}>
      <div className={styles.mainPageContainer}>
        <h2 className={styles.mainPageHeader}>Recruiter Login</h2>
        <form onSubmit={handleLogin} className={styles.mainPageForm}>
          <div>
            <label className={styles.mainPageLabel}>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className={styles.mainPageInput}
            />
          </div>
          <div>
            <label className={styles.mainPageLabel}>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={styles.mainPageInput}
            />
          </div>
          {errorMessage && <p className={styles.mainPageErrorMessage}>{errorMessage}</p>}
          <button type="submit" className={styles.mainPageButton} disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p style={{ marginTop: '20px' }}>
          Not yet registered as a recruiter?{' '}
          <Link to="/recruiter/register" className={styles.registerLink}>
            Register here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
